// Version : 0.0.1
// Author : AGALYA

import RecurringDepositProposalActionTypes from './recurring-deposit-proposal.types';

/** ***************** CREATE RECURRING DEPOSIT PROPOSAL START *********************** */
export const addRecurringDepositProposalStart = (addData: any) => ({
	type: RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_START,
	payload: addData,
});

export const addRecurringDepositProposalSuccess = (successData: any) => ({
	type: RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_SUCCESS,
	payload: successData,
});

export const addRecurringDepositProposalFailure = (failureData: any) => ({
	type: RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_FAILURE,
	payload: failureData,
});

export const addRecurringDepositProposalResponseResetStart = () => ({
	type: RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_RESPONSE_RESET,
});

export const addRecurringDepositProposalResponseChanged = () => ({
	type: RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** CREATE RECURRING DEPOSIT PROPOSAL END *********************** */

/** ***************** UPDATE RECURRING DEPOSIT PROPOSAL START *********************** */
export const updateRecurringDepositProposalStart = (updateData: any) => ({
	type: RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_START,
	payload: updateData,
});

export const updateRecurringDepositProposalSuccess = (successData: any) => ({
	type: RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_SUCCESS,
	payload: successData,
});

export const updateRecurringDepositProposalFailure = (failureData: any) => ({
	type: RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_FAILURE,
	payload: failureData,
});

export const updateRecurringDepositProposalResponseResetStart = () => ({
	type: RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_RESPONSE_RESET,
});

export const updateRecurringDepositProposalResponseChanged = () => ({
	type: RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** UPDATE RECURRING DEPOSIT PROPOSAL END *********************** */

/** ***************** FETCH RECURRING DEPOSIT PROPOSAL START *********************** */
export const fetchRecurringDepositProposalStart = (fetchData: any) => ({
	type: RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_START,
	payload: fetchData,
});

export const fetchRecurringDepositProposalSuccess = (successData: any) => ({
	type: RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_SUCCESS,
	payload: successData,
});

export const fetchRecurringDepositProposalFailure = (failureData: any) => ({
	type: RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_FAILURE,
	payload: failureData,
});

export const fetchRecurringDepositProposalResponseResetStart = () => ({
	type: RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_RESPONSE_RESET,
});

export const fetchRecurringDepositProposalResponseChanged = () => ({
	type: RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** FETCH RECURRING DEPOSIT PROPOSAL END *********************** */

/** ***************** GET RECURRING DEPOSIT PROPOSAL START *********************** */
export const getRecurringDepositProposalStart = (getData: any) => ({
	type: RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_START,
	payload: getData,
});

export const getRecurringDepositProposalSuccess = (successData: any) => ({
	type: RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_SUCCESS,
	payload: successData,
});

export const getRecurringDepositProposalFailure = (failureData: any) => ({
	type: RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_FAILURE,
	payload: failureData,
});

export const getRecurringDepositProposalResponseResetStart = () => ({
	type: RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_RESPONSE_RESET,
});

export const getRecurringDepositProposalResponseChanged = () => ({
	type: RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** GET RECURRING DEPOSIT PROPOSAL END *********************** */

/** ***************** DELETE RECURRING DEPOSIT PROPOSAL START *********************** */
export const deleteRecurringDepositProposalStart = (deleteData: any) => ({
	type: RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_START,
	payload: deleteData,
});

export const deleteRecurringDepositProposalSuccess = (successData: any) => ({
	type: RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_SUCCESS,
	payload: successData,
});

export const deleteRecurringDepositProposalFailure = (failureData: any) => ({
	type: RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_FAILURE,
	payload: failureData,
});

export const deleteRecurringDepositProposalResponseResetStart = () => ({
	type: RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_RESPONSE_RESET,
});

export const deleteRecurringDepositProposalResponseChanged = () => ({
	type: RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** DELETE RECURRING DEPOSIT PROPOSAL END *********************** */
